<template>
  <main class="spin-page">
    <section v-if="showLoading" class="loading-screen">
      <img
        class="loading-screen__logo"
        src="../assets/images/logo2.png"
        alt="UFAEASY 888"
      />
      <lottie
        v-if="defaultOptions"
        :options="defaultOptions"
        :height="260"
        :width="260"
        @animCreated="handleAnimation"
      />
      <p>กำลังเตรียมวงล้อแห่งโชค...</p>
    </section>

    <section v-else class="game-screen">
      <div class="game-screen__noise"></div>
      <div class="game-screen__glow game-screen__glow--left"></div>
      <div class="game-screen__glow game-screen__glow--right"></div>

      <header class="game-header">
        <div class="brand">
          <img
            class="brand__mark"
            src="../assets/images/logo2.png"
            alt="UFAEASY 888"
          />
          <div class="brand__copy">
            <span>UFAEASY 888</span>
            <strong>ROYAL REWARDS</strong>
          </div>
        </div>

        <div class="game-header__info">
          <div class="balance-pill" aria-label="ยอด Coin คงเหลือ">
            <span class="balance-pill__coin">
              <img src="../assets/images/coin.png" alt="" />
            </span>
            <span class="balance-pill__copy">
              <small>Coin ของคุณ</small>
              <strong>{{ mycoin.toLocaleString() }}</strong>
            </span>
          </div>
          <div
            v-if="pictureUrl && pictureUrl !== 'none'"
            class="game-header__avatar"
            :style="{ backgroundImage: `url(${pictureUrl})` }"
            aria-label="รูปโปรไฟล์"
          ></div>
        </div>
      </header>

      <section class="hero-copy">
        <div class="hero-copy__eyebrow">
          <span></span>
          <p>EXCLUSIVE MEMBER PRIVILEGE</p>
          <span></span>
        </div>
        <h1>วงล้อ<span>มหาเฮง</span></h1>
        <p>หมุนรับโชค ลุ้นรางวัลพิเศษสำหรับสมาชิกคนสำคัญ</p>
      </section>

      <section class="spin-card">
        <div class="spin-card__topline">
          <div>
            <small>สิทธิ์ประจำวัน</small>
            <strong>
              <span>{{ running ? 0 : 1 }}</span>
              / 1 ครั้ง
            </strong>
          </div>
          <p :class="{ 'spin-card__status--active': running }">
            <span></span>
            {{ running ? "กำลังหมุน" : "พร้อมลุ้นรางวัล" }}
          </p>
        </div>

        <div class="live-wheel-stage">
          <div
            class="live-wheel-stage__halo live-wheel-stage__halo--outer"
          ></div>
          <div
            class="live-wheel-stage__halo live-wheel-stage__halo--inner"
          ></div>

          <div class="live-wheel-pointer" aria-hidden="true">
            <span></span>
          </div>

          <div class="live-wheel-shell">
            <span
              v-for="lightIndex in 20"
              :key="`light-${lightIndex}`"
              class="live-wheel-light"
              :class="{ 'live-wheel-light--bright': lightIndex % 2 === 0 }"
              :style="{
                transform: `rotate(${(lightIndex - 1) *
                  18}deg) translateY(calc(var(--light-radius) * -1))`
              }"
            ></span>
            <canvas id="canvas" ref="wheelCanvas"></canvas>
          </div>

          <p class="live-wheel-stage__hint">
            <span aria-hidden="true"></span>
            {{
              running ? "วงล้อกำลังเลือกรางวัลของคุณ" : "แตะวงล้อเพื่อเริ่มลุ้น"
            }}
            <span aria-hidden="true"></span>
          </p>
        </div>

        <div class="game-status">
          <span class="game-status__dot"></span>
          <p>{{ loadingtext }}</p>
        </div>
      </section>
    </section>
  </main>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
const axios = require("axios").default;
import router from "./../router";
import Lottie from "./lottie.vue";
import { buildRewardFlex } from "@/services/rewardFlex";
import { loadAnimation } from "@/services/lottieLoader";
import liffService from "@/services/liff";
const audio = new Audio(require("../assets/wolf_howling.mp3"));
// @ is an alias to /src
export default {
  name: "Spin",
  async created() {
    const animate = await loadAnimation("SmileAngle");
    this.defaultOptions = {
      animationData: animate,
      autoplay: false,
      loop: false
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleWheelResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWheelResize);
  },
  components: {
    lottie: Lottie
  },
  data() {
    return {
      showLoading: true,
      loadingtext: "น้องออโต้กำลังประมวลผลให้อยู่ค่ะ รอสักครู่",
      displayName: "",
      //email: "",
      userId: "", //Uf67a993bc2d1d206693634a1ba806798
      pictureUrl: "",
      statusMessage: "",
      firstname: "",
      master: "5",
      agent: "-MBjPYX3fRJGs3gklUHq",
      lastname: "",
      bank: "",
      accountNo: "",
      tel: "",
      mastername: "",
      isDisabled: true,
      loading: true,
      error: "",
      mycoin: 0,
      rewards: [],
      userKey: "",
      quizId: 0,
      answer: 0,
      running: false,
      angle: 0,
      sections: [
        "3 Coins",
        "10 Coins",
        "5 Coins",
        "3 Coins",
        "7 Coins",
        "30 Coins",
        "3 Coins",
        "5 Coins",
        "10 Coins",
        "3 Coins",
        "30 Coins",
        "7 Coins",
        "3 Coins",
        "5 Coins",
        "50 Coins",
        "0 Coins",
        "100 Coins"
      ],
      sections2000: [
        "6 Coins",
        "20 Coins",
        "10 Coins",
        "6 Coins",
        "14 Coins",
        "60 Coins",
        "6 Coins",
        "10 Coins",
        "20 Coins",
        "6 Coins",
        "60 Coins",
        "14 Coins",
        "6 Coins",
        "10 Coins",
        "100 Coins",
        "0 Coins",
        "200 Coins"
      ],
      colors: [
        "#b00035",
        "#f5f3ef",
        "#92002d",
        "#f5f3ef",
        "#c0063f",
        "#f5f3ef",
        "#a40033",
        "#f5f3ef",
        "#b7003a",
        "#f5f3ef",
        "#9b0031",
        "#f5f3ef",
        "#bd063e",
        "#f5f3ef",
        "#a90035",
        "#f5f3ef",
        "#d8961f"
      ],
      textColors: [
        "#fff9ed",
        "#3d3e43",
        "#fff9ed",
        "#3d3e43",
        "#fff9ed",
        "#3d3e43",
        "#fff9ed",
        "#3d3e43",
        "#fff9ed",
        "#3d3e43",
        "#fff9ed",
        "#3d3e43",
        "#fff9ed",
        "#3d3e43",
        "#fff1bd",
        "#3d3e43",
        "#4a2807"
      ],
      //colors : ["#F84", "#8F4", "#48F", "#F8F","#F84", "#8F4", "#48F", "#F8F", "#F84", "#8F4", "#48F", "#F8F","#666666","#fcd846"],
      wheels: null,
      frame: null,
      canvas: null,
      defaultOptions: null
    };
  },
  methods: {
    playSound() {
      audio.volume = 0.6;
      audio.play();
    },
    handleAnimation: function(anim) {
      this.anim = anim;
      this.anim.play();
      this.playSound();
      setTimeout(() => {
        this.showLoading = false;
        this.anim.stop();
        setTimeout(() => {
          // LIFF is already initialized by router guard
          this.loadUserData();
        }, 100);
      }, 3200);
    },
    handleWheelResize() {
      if (!this.canvas) return;

      this.wheels = null;
      this.frame = null;
      this.repaint(this.angle);
    },
    repaint(angle) {
      if (!this.canvas) return;

      const wheelHost = this.canvas.parentElement;
      const bounds = wheelHost.getBoundingClientRect();
      const canvasSize = Math.max(
        260,
        Math.floor(Math.min(bounds.width, bounds.height))
      );
      const r = Math.floor((canvasSize - 10) / 2.2);

      if (this.wheels === null) {
        this.wheels = [];
        for (let selected = 0; selected < this.sections.length; selected++) {
          const c = document.createElement("canvas");
          c.width = c.height = 2 * r + 10;
          const ctx = c.getContext("2d"),
            cx = 5 + r,
            cy = 5 + r;
          const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
          g.addColorStop(0, "rgba(255,255,255,0.08)");
          g.addColorStop(0.72, "rgba(255,255,255,0)");
          g.addColorStop(1, "rgba(0,0,0,0.18)");
          for (let i = 0; i < this.sections.length; i++) {
            const a0 = (2 * Math.PI * i) / this.sections.length;
            const a1 = a0 + (2 * Math.PI) / (i == 0 ? 1 : this.sections.length);
            const a = (2 * Math.PI * (i + 0.5)) / this.sections.length;
            ctx.beginPath();
            ctx.moveTo(cx, cy);
            ctx.arc(cx, cy, r, a0, a1, false);
            ctx.fillStyle = this.colors[i];
            ctx.fill();
            ctx.strokeStyle = "rgba(125,80,18,0.42)";
            ctx.lineWidth = Math.max(1, r / 150);
            ctx.stroke();
            ctx.fillStyle = g;
            ctx.fill();
            ctx.save();
            ctx.fillStyle = this.textColors[i];
            if (i == selected) {
              ctx.shadowColor = "#ffe19a";
              ctx.shadowBlur = r / 18;
            }
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.translate(cx, cy);
            ctx.rotate(a);
            const amount = this.sections[i].split(" ")[0];
            ctx.font =
              "700 " +
              Math.max(10, (r / this.sections.length) * 1.55) +
              "px Georgia";
            ctx.fillText(amount, r * 0.67, -4);
            ctx.font =
              "600 " +
              Math.max(6, (r / this.sections.length) * 0.76) +
              "px Tahoma";
            ctx.fillText("Coin", r * 0.67, 8);
            ctx.restore();
          }
          this.wheels.push(c);
        }
      }
      if (this.frame === null) {
        this.frame = document.createElement("canvas");
        this.frame.width = this.frame.height = (10 + 2 * r * 1.1) | 0;
        const ctx = this.frame.getContext("2d"),
          cx = this.frame.width / 2,
          cy = this.frame.height / 2;
        const rim = ctx.createLinearGradient(cx - r, cy - r, cx + r, cy + r);
        rim.addColorStop(0, "#fff0ad");
        rim.addColorStop(0.2, "#b66c15");
        rim.addColorStop(0.48, "#ffd977");
        rim.addColorStop(0.73, "#8a4a0e");
        rim.addColorStop(1, "#ffe69a");
        ctx.beginPath();
        ctx.arc(cx, cy, r * 1.028, 0, 2 * Math.PI, true);
        ctx.arc(cx, cy, r * 0.975, 0, 2 * Math.PI, false);
        ctx.fillStyle = rim;
        ctx.fill();

        ctx.save();
        ctx.shadowColor = "rgba(0,0,0,0.55)";
        ctx.shadowBlur = r / 18;
        const hub = ctx.createRadialGradient(
          cx - r / 10,
          cy - r / 10,
          0,
          cx,
          cy,
          r / 2.5
        );
        hub.addColorStop(0, "#fff3b9");
        hub.addColorStop(0.42, "#efbc4e");
        hub.addColorStop(0.72, "#ad6716");
        hub.addColorStop(1, "#5d3008");
        ctx.fillStyle = hub;
        ctx.beginPath();
        ctx.arc(cx, cy, r * 0.31, 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.restore();

        ctx.strokeStyle = "#f4ca68";
        ctx.lineWidth = Math.max(2, r / 45);
        ctx.beginPath();
        ctx.arc(cx, cy, r * 0.31, 0, 2 * Math.PI);
        ctx.stroke();

        ctx.fillStyle = "#4f2608";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = "700 " + Math.max(18, r * 0.16) + "px Georgia";
        ctx.fillText("SPIN", cx, cy - r * 0.015);
        ctx.font = "600 " + Math.max(7, r * 0.045) + "px Tahoma";
        ctx.fillText("กดเพื่อหมุน", cx, cy + r * 0.12);
      }

      this.canvas.width = canvasSize;
      this.canvas.height = canvasSize;
      const cx = canvasSize / 2,
        cy = canvasSize / 2;
      const ctx = this.canvas.getContext("2d");
      let selected =
        Math.floor(((-0.2 - angle) * this.sections.length) / (2 * Math.PI)) %
        this.sections.length;
      if (selected < 0) selected += this.sections.length;
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(angle - Math.PI / 2 + 0.2);
      ctx.translate(
        -this.wheels[selected].width / 2,
        -this.wheels[selected].height / 2
      );
      ctx.drawImage(this.wheels[selected], 0, 0);
      ctx.restore();
      ctx.drawImage(
        this.frame,
        cx - this.frame.width / 2,
        cy - this.frame.height / 2
      );
    },
    spinTo(winner, duration) {
      const finalAngle =
        -0.2 - ((0.5 + winner) * 2 * Math.PI) / this.sections.length;
      const startAngle =
        this.angle -
        Math.floor(this.angle / (2 * Math.PI)) * 2 * Math.PI -
        5 * 2 * Math.PI;
      const start = performance.now();
      const frame = () => {
        const now = performance.now();
        let t = Math.min(1, (now - start) / duration);
        t = 3 * t * t - 2 * t * t * t; // ease in out
        this.angle = startAngle + t * (finalAngle - startAngle);
        this.repaint(this.angle);
        if (t < 1) requestAnimationFrame(frame);
        else {
          const coin = this.sections[winner].split(" ");
          if (Number(coin[0]) > 0) {
            this.mycoin += Number(coin[0]);
            this.$confirm({
              message: `🎡 ปังปุรีเย่!! คุณได้รับ ${this.sections[winner]} 😘😘`,
              button: {
                yes: "OK"
              },
              callback: confirm => {
                if (confirm) {
                  //this.sendMessageLine(`ปังปุรีเย่!! คุณได้รับ ${this.sections[winner]} 😘😘`);
                  this.sendMessageLine3(this.sections[winner]);
                }
              }
            });
          } else {
            this.$confirm({
              message: `🎡 TT พรุ่งนี้มาหมุนด้วยกันใหม่นะคะ 😘😘`,
              button: {
                yes: "OK"
              },
              callback: confirm => {
                if (confirm) {
                  this.sendMessageLine(`TT พรุ่งนี้มาหมุนด้วยกันใหม่นะคะ 😘😘`);
                }
              }
            });
          }
        }
      };
      requestAnimationFrame(frame);
      this.running = true;
    },
    async sendMessageLine(text) {
      await window.liff.sendMessages([
        {
          type: "text",
          text: "🎡 " + text
        }
      ]);
      window.liff.closeWindow();
    },
    async sendMessageLine2(text) {
      await window.liff.sendMessages([
        {
          type: "text",
          text: "🎡 " + text
        }
      ]);
    },
    async sendMessageLine3(text) {
      // text เช่น "3 Coins" -> การ์ดโทนดำทอง (services/rewardFlex.js)
      const amount = parseInt(String(text).replace(/,/g, ""), 10) || 0;
      await window.liff.sendMessages([buildRewardFlex("spin", amount)]);
      window.liff.closeWindow();
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      let profile = liffService.profile;

      // Development mode: use mock profile on localhost
      const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";
      if (isLocalhost && !profile) {
        profile = {
          userId: "dev-test-user",
          displayName: "Dev Tester",
          pictureUrl: "",
          statusMessage: ""
        };
      }

      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      this.displayName = profile.displayName ? profile.displayName : "none";
      this.statusMessage = profile.statusMessage
        ? profile.statusMessage
        : "none";
      if (this.userId) {
        // Development mode: show wheel directly on localhost
        if (isLocalhost) {
          this.mycoin = 999;
          this.canvas = document.getElementById("canvas");
          this.repaint(this.angle);
          this.loadingtext = "[DEV] คลิกที่วงล้อเพื่อหมุน";
          this.canvas.onmousedown = () => {
            if (!this.running) {
              const rand = this.randomFixed();
              this.spinTo(rand, 5000);
            }
          };
          return;
        }

        const user = (
          await firebase
            .database()
            .ref(`/users`)
            .orderByChild("userId")
            .equalTo(this.userId)
            .once("value")
        ).val();
        if (user) {
          const u = user[Object.keys(user)[0]];
          this.mycoin = u.coins ? u.coins : 0;
          this.userKey = Object.keys(user)[0];
          this.sendMessageLine2("สนใจเล่นหมุนวงล้อ พลอยใสจัดการให้หน่อย 😘😘");
          await firebase
            .firestore()
            .collection("spin")
            .doc(
              this.userId +
                "-" +
                moment()
                  .tz("Asia/Bangkok")
                  .format("YYYY-MM-DD")
            )
            .get()
            .then(async snapshot => {
              if (snapshot.exists) {
                this.sendMessageLine(
                  "ลูกค้าหมุนวงล้อของเราไปแล้วนะคะวันนี้ รอวันพรุ่งนี้นะคะ 😘😘"
                );
              } else {
                this.canvas = document.getElementById("canvas");
                this.repaint(this.angle);
                await firebase
                  .firestore()
                  .collection("history")
                  .where("userId", "==", this.userId)
                  .where("type", "==", "ฝาก")
                  .where("status", "==", "ดำเนินการแล้ว")
                  .where(
                    "createdate",
                    ">=",
                    moment()
                      .tz("Asia/Bangkok")
                      .format("YYYY-MM-DD") + " 00:00:00"
                  )
                  .where(
                    "createdate",
                    "<=",
                    moment()
                      .tz("Asia/Bangkok")
                      .format("YYYY-MM-DD") + " 23:59:59"
                  )
                  .get()
                  .then(async snapshot => {
                    let credit = 0;
                    snapshot.forEach(doc => {
                      credit += Number(doc.data().qty);
                    });
                    if (credit >= 500) {
                      this.loadingtext = "น้องออโต้พร้อมแล้ว หมุนได้เลยค่ะ😘😘";
                      this.canvas.onmousedown = () => {
                        if (!this.running) {
                          const rand = this.randomFixed();
                          setTimeout(() => {
                            if (this.userId) {
                              const coin = this.sections[rand].split(" ");
                              firebase
                                .firestore()
                                .collection("spin")
                                .doc(
                                  this.userId +
                                    "-" +
                                    moment()
                                      .tz("Asia/Bangkok")
                                      .format("YYYY-MM-DD")
                                )
                                .set({
                                  userId: this.userId,
                                  createdate: moment()
                                    .tz("Asia/Bangkok")
                                    .format("YYYY-MM-DD HH:mm:ss"),
                                  spin: this.sections[rand],
                                  value: Number(coin[0])
                                });
                            }
                          }, 1000);
                          this.spinTo(rand, 5000);
                        }
                      };
                    } else {
                      const less = 500 - Number(credit);
                      this.loadingtext = `เติมเงินอีก ${less}(500) ได้เล่นเลยค่ะ!😘😘`;
                    }
                  });
              }
            });
        } else {
          router.replace("/register");
        }
      }
      this.isDisabled = false;
    },
    randomFixed() {
      let rand = (Math.random() * this.sections.length) | 0;
      if (rand == 16 || rand == -1 || rand == 14) {
        //|| rand == 14 || rand == 5 || rand == 10
        //if (rand == 16 || rand ==-1 || rand == 14 || rand == 16) {
        rand = this.randomFixed();
      }
      //  else if(this.userId === 'Ub0f3cf221781245f76a624135f929cbe'){
      //    rand = 16;
      //  }
      /* if(this.userId === 'U10007b326326ac35be8aeb34436cd434') { //ufs896v0927
          rand = 3
        }else if(this.userId === 'U66f9b486ab6e36b32d4a25daa07cb531') { //ufs896v1053
          rand = 15
        }else if(this.userId === 'Uded86f8a1be92ebd0c1ed4ae05fc5e8a') { //ufs896v1089
          rand = 15
        }else if(this.userId === 'U72fea0c58cb9fdbc39d5be261a996011') { //ufs896v0885
          rand = 3
        }else if(this.userId === 'Uc551b3baf81999c7338c7918f595c80c') { //ufs896v1137
          rand = 15
        }*/
      return rand;
    }
  }
};
</script>
<style lang="scss" scoped>
.spin-page {
  min-height: 100vh;
  background: #26272c;
  font-family: "Tahoma", sans-serif;
}

.loading-screen {
  position: fixed;
  inset: 0;
  z-index: 20;
  display: flex;
  padding: calc(20px + env(safe-area-inset-top, 0px)) 20px
    calc(20px + env(safe-area-inset-bottom, 0px));
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: radial-gradient(
      circle at 50% 45%,
      rgba(173, 0, 52, 0.2),
      transparent 35%
    ),
    linear-gradient(155deg, #6d6e73, #3d3e43 48%, #202126);
  color: rgba(255, 246, 222, 0.72);
}

.loading-screen__logo {
  width: 108px;
  height: 86px;
  margin-bottom: -8px;
  object-fit: contain;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.38));
}

.loading-screen p {
  margin-top: -10px;
  font-size: 12px;
  letter-spacing: 0.03em;
}

.game-screen {
  position: fixed;
  inset: 0;
  overflow: hidden;
  padding: calc(14px + env(safe-area-inset-top, 0px)) clamp(14px, 4vw, 24px)
    calc(20px + env(safe-area-inset-bottom, 0px));
  background: radial-gradient(
      circle at 50% 43%,
      rgba(151, 0, 43, 0.18),
      transparent 32%
    ),
    radial-gradient(circle at 92% 56%, rgba(255, 162, 34, 0.2), transparent 36%),
    radial-gradient(circle at 8% 86%, rgba(200, 124, 22, 0.16), transparent 30%),
    linear-gradient(155deg, #727378 0%, #4a4b50 42%, #222329 100%);
  color: #fff8e8;
  isolation: isolate;
}

.game-screen::before {
  content: "";
  position: absolute;
  z-index: 0;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(
      circle at 14% 20%,
      rgba(255, 225, 150, 0.62) 0 1px,
      transparent 2px
    ),
    radial-gradient(
      circle at 84% 12%,
      rgba(255, 198, 93, 0.52) 0 1px,
      transparent 2px
    ),
    linear-gradient(
      118deg,
      transparent 49.7%,
      rgba(255, 218, 149, 0.08) 50%,
      transparent 50.3%
    );
  background-size: 128px 146px, 176px 194px, 96px 160px;
  opacity: 0.78;
}

.game-screen::after {
  content: "";
  position: absolute;
  z-index: 0;
  right: -390px;
  top: 35%;
  width: 720px;
  height: 270px;
  border: 2px solid rgba(255, 177, 60, 0.32);
  border-radius: 50%;
  pointer-events: none;
  transform: rotate(-14deg);
  box-shadow: 0 0 10px rgba(255, 171, 43, 0.52),
    0 0 0 7px rgba(255, 205, 119, 0.06), 0 0 0 20px rgba(255, 165, 35, 0.04);
}

.game-screen__noise {
  position: fixed;
  z-index: 20;
  inset: 0;
  pointer-events: none;
  opacity: 0.035;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.7'/%3E%3C/svg%3E");
}

.game-screen__glow {
  position: absolute;
  z-index: 1;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(22px);
  opacity: 0.34;
}

.game-screen__glow--left {
  left: -150px;
  top: 24%;
  background: #8f002c;
}

.game-screen__glow--right {
  right: -170px;
  top: 54%;
  background: #e29a2b;
}

.game-header {
  position: relative;
  z-index: 4;
  display: flex;
  width: min(100%, 560px);
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
}

.brand {
  display: flex;
  min-width: 0;
  align-items: center;
}

.brand__mark {
  width: 58px;
  height: 58px;
  object-fit: contain;
  filter: drop-shadow(0 5px 11px rgba(0, 0, 0, 0.45));
}

.brand__copy {
  display: flex;
  margin-left: -4px;
  flex-direction: column;
}

.brand__copy span {
  color: #ffe29a;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
}

.brand__copy strong {
  margin-top: 2px;
  color: rgba(255, 241, 209, 0.65);
  font-size: 8px;
  letter-spacing: 0.24em;
}

.game-header__info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.game-header__avatar {
  width: 36px;
  height: 36px;
  border: 2px solid #e7b64f;
  border-radius: 50%;
  flex-shrink: 0;
  background-position: center;
  background-size: cover;
  box-shadow: 0 0 12px rgba(230, 178, 68, 0.32);
}

.balance-pill {
  display: flex;
  min-width: 116px;
  padding: 6px 11px 6px 7px;
  border: 1px solid rgba(255, 212, 123, 0.48);
  border-radius: 999px;
  align-items: center;
  background: linear-gradient(
    145deg,
    rgba(255, 247, 218, 0.15),
    rgba(39, 39, 43, 0.72)
  );
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18),
    0 7px 21px rgba(0, 0, 0, 0.3), 0 0 16px rgba(244, 164, 44, 0.09);
  backdrop-filter: blur(12px);
}

.balance-pill__coin {
  display: grid;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
  place-items: center;
  background: radial-gradient(circle, #efcf77, #9d661a);
  box-shadow: 0 0 10px rgba(230, 181, 79, 0.26);
}

.balance-pill__coin img {
  width: 27px;
  height: 27px;
  object-fit: contain;
}

.balance-pill__copy {
  display: flex;
  margin-left: 8px;
  flex-direction: column;
}

.balance-pill__copy small {
  color: rgba(255, 242, 215, 0.68);
  font-size: 8px;
}

.balance-pill__copy strong {
  margin-top: 1px;
  color: #ffe89e;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 17px;
  line-height: 1;
}

.hero-copy {
  position: relative;
  z-index: 2;
  margin: clamp(13px, 3.5vh, 30px) auto clamp(10px, 2vh, 18px);
  text-align: center;
}

.hero-copy__eyebrow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.hero-copy__eyebrow span {
  width: 28px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #d2a84d);
}

.hero-copy__eyebrow span:last-child {
  transform: rotate(180deg);
}

.hero-copy__eyebrow p {
  color: #ffd787;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(8px, 2.2vw, 10px);
  letter-spacing: 0.18em;
}

.hero-copy h1 {
  margin: 5px 0 2px;
  font-family: Georgia, "Times New Roman", "Tahoma", serif;
  font-size: clamp(31px, 8.2vw, 48px);
  font-weight: 400;
  line-height: 1.06;
  letter-spacing: -0.04em;
  text-shadow: 0 5px 22px rgba(0, 0, 0, 0.5);
}

.hero-copy h1 span {
  margin-left: 8px;
  background: linear-gradient(180deg, #fff4c8 10%, #ffbd3f 52%, #d97808 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 700;
}

.hero-copy > p {
  color: rgba(255, 249, 231, 0.74);
  font-size: clamp(11px, 3vw, 13px);
}

.spin-card {
  position: relative;
  z-index: 2;
  width: min(100%, 520px);
  margin: 0 auto;
  padding: 13px 11px 14px;
  border: 1px solid rgba(255, 208, 112, 0.34);
  border-radius: 26px;
  background: linear-gradient(
      150deg,
      rgba(255, 255, 255, 0.08),
      transparent 32%
    ),
    linear-gradient(180deg, rgba(70, 70, 75, 0.76), rgba(29, 29, 34, 0.9));
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.14), 0 0 34px rgba(183, 0, 55, 0.08);
  backdrop-filter: blur(8px);
}

.spin-card::before {
  content: "";
  position: absolute;
  inset: 5px;
  border: 1px solid rgba(255, 232, 178, 0.11);
  border-radius: 21px;
  pointer-events: none;
}

.spin-card__topline {
  position: relative;
  z-index: 3;
  display: flex;
  margin: 0 8px 10px;
  align-items: flex-end;
  justify-content: space-between;
}

.spin-card__topline > div {
  display: flex;
  flex-direction: column;
}

.spin-card__topline small {
  color: rgba(255, 241, 213, 0.6);
  font-size: 9px;
}

.spin-card__topline strong {
  margin-top: 2px;
  color: #f4e3bd;
  font-size: 12px;
}

.spin-card__topline strong span {
  color: #ffe694;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 20px;
}

.spin-card__topline > p {
  display: flex;
  padding-bottom: 3px;
  align-items: center;
  gap: 6px;
  color: rgba(255, 242, 215, 0.7);
  font-size: 10px;
}

.spin-card__topline > p span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffbd4b;
  box-shadow: 0 0 9px rgba(255, 173, 42, 0.9);
}

.spin-card__status--active span {
  animation: statusPulse 0.7s ease-in-out infinite alternate;
}

.live-wheel-stage {
  --wheel-size: min(82vw, 390px, 49vh);
  --light-radius: calc(var(--wheel-size) * 0.478);
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  isolation: isolate;
}

.live-wheel-stage__halo {
  position: absolute;
  left: 50%;
  top: calc(var(--wheel-size) / 2);
  border-radius: 50%;
  pointer-events: none;
  transform: translate(-50%, -50%);
}

.live-wheel-stage__halo--outer {
  width: calc(var(--wheel-size) * 1.34);
  height: calc(var(--wheel-size) * 1.34);
  background: radial-gradient(
    circle,
    rgba(255, 201, 91, 0.28),
    rgba(177, 0, 50, 0.12) 45%,
    transparent 70%
  );
  filter: blur(15px);
  animation: haloBreath 3.2s ease-in-out infinite;
}

.live-wheel-stage__halo--inner {
  width: calc(var(--wheel-size) * 1.08);
  height: calc(var(--wheel-size) * 1.08);
  border: 1px solid rgba(255, 229, 164, 0.22);
  box-shadow: 0 0 45px rgba(243, 191, 91, 0.18);
}

.live-wheel-pointer {
  position: absolute;
  top: calc(var(--wheel-size) * -0.015);
  left: 50%;
  z-index: 10;
  width: calc(var(--wheel-size) * 0.14);
  height: calc(var(--wheel-size) * 0.2);
  transform: translateX(-50%);
  clip-path: polygon(50% 100%, 2% 14%, 24% 0, 76% 0, 98% 14%);
  background: linear-gradient(90deg, #16171a 0%, #4a4b50 48%, #111216 100%);
  filter: drop-shadow(0 8px 7px rgba(0, 0, 0, 0.52));
  pointer-events: none;
}

.live-wheel-pointer::after {
  content: "";
  position: absolute;
  inset: 5px;
  clip-path: inherit;
  background: linear-gradient(145deg, #55565a, #25262a 48%, #0d0e10 80%);
}

.live-wheel-pointer span {
  position: absolute;
  left: 50%;
  top: 14%;
  z-index: 1;
  width: 28%;
  aspect-ratio: 1;
  border: 1px solid rgba(255, 255, 255, 0.95);
  transform: translateX(-50%) rotate(45deg);
  background: linear-gradient(145deg, #ffffff, #eee8dc 48%, #9fa0a4);
  box-shadow: 0 0 12px rgba(255, 239, 196, 0.9);
}

.live-wheel-shell {
  position: relative;
  width: var(--wheel-size);
  height: var(--wheel-size);
  border-radius: 50%;
  background: radial-gradient(
      circle at 35% 30%,
      rgba(255, 255, 255, 0.94) 0 1%,
      transparent 2%
    ),
    linear-gradient(
      145deg,
      #fff1b7 0%,
      #b36a17 22%,
      #f6d777 48%,
      #72400d 72%,
      #ffeaa5 100%
    );
  box-shadow: 0 26px 58px rgba(0, 0, 0, 0.56),
    0 0 0 2px rgba(255, 231, 173, 0.42), 0 0 32px rgba(221, 160, 57, 0.28),
    inset 0 0 0 3px rgba(78, 39, 6, 0.7);
}

.live-wheel-shell::after {
  content: "";
  position: absolute;
  z-index: 6;
  inset: 0;
  border-radius: 50%;
  pointer-events: none;
  background: linear-gradient(
    128deg,
    rgba(255, 255, 255, 0.16),
    transparent 24% 69%,
    rgba(73, 31, 0, 0.12)
  );
}

.live-wheel-light {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 7;
  width: calc(var(--wheel-size) * 0.022);
  height: calc(var(--wheel-size) * 0.022);
  margin: calc(var(--wheel-size) * -0.011);
  border-radius: 50%;
  pointer-events: none;
  background: #fff2b0;
  box-shadow: 0 0 8px #ffc95d, 0 0 15px rgba(255, 214, 106, 0.72);
}

.live-wheel-light--bright {
  background: #ffffff;
  box-shadow: 0 0 9px #fff, 0 0 17px #ffd066, 0 0 25px rgba(255, 185, 45, 0.7);
  animation: jewelBlink 1.6s ease-in-out infinite alternate;
}

#canvas {
  position: absolute;
  z-index: 3;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  max-width: none;
  border-radius: 50%;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.live-wheel-stage__hint {
  display: flex;
  margin-top: 16px;
  align-items: center;
  gap: 12px;
  color: rgba(255, 244, 219, 0.78);
  font-size: clamp(11px, 3vw, 13px);
  font-weight: 500;
  letter-spacing: 0.02em;
}

.live-wheel-stage__hint span {
  width: 20px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(229, 190, 99, 0.7));
}

.live-wheel-stage__hint span:last-child {
  transform: rotate(180deg);
}

.game-status {
  position: relative;
  z-index: 3;
  display: flex;
  width: fit-content;
  max-width: calc(100% - 16px);
  margin: 11px auto 0;
  padding: 8px 13px;
  border: 1px solid rgba(255, 211, 119, 0.2);
  border-radius: 999px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background: rgba(28, 28, 32, 0.62);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.game-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #ffbd4b;
  box-shadow: 0 0 9px rgba(255, 173, 42, 0.9);
}

.game-status p {
  overflow: hidden;
  color: rgba(255, 245, 222, 0.76);
  font-size: clamp(9px, 2.5vw, 11px);
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes statusPulse {
  from {
    opacity: 0.45;
    transform: scale(0.78);
  }
  to {
    opacity: 1;
    transform: scale(1.08);
  }
}

@keyframes haloBreath {
  0%,
  100% {
    opacity: 0.55;
    transform: translate(-50%, -50%) scale(0.96);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.04);
  }
}

@keyframes jewelBlink {
  from {
    opacity: 0.62;
    filter: brightness(0.76);
  }
  to {
    opacity: 1;
    filter: brightness(1.3);
  }
}

@media (max-height: 730px) {
  .hero-copy {
    margin-top: 7px;
    margin-bottom: 7px;
  }

  .hero-copy h1 {
    font-size: clamp(28px, 7.5vw, 38px);
  }

  .spin-card {
    padding-bottom: 10px;
  }

  .live-wheel-stage {
    --wheel-size: min(74vw, 335px, 44vh);
  }

  .live-wheel-stage__hint {
    margin-top: 10px;
  }

  .game-status {
    margin-top: 8px;
    padding-block: 6px;
  }
}

@media (max-width: 350px) {
  .brand__copy,
  .game-header__avatar {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .live-wheel-stage__halo--outer,
  .live-wheel-light--bright,
  .spin-card__status--active span {
    animation: none;
  }
}
</style>
